module.exports = __webpack_public_path__ + "img/ic_xinzeng@2x.1ad05d74.png";